<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'PAGES.SFTP.TITLE' | translate }}</glxy-page-title>
    <glxy-page-actions>
      <button mat-flat-button color="primary" (click)="showAddKeyDialog()">
        <mat-icon>vpn_key</mat-icon>
        {{ 'PAGES.SFTP.BUTTONS.ADD_KEY' | translate }}
      </button>
      <a class="toolbar-help-button" mat-icon-button target="_blank" href="https://websitepro.zendesk.com/hc/en-us">
        <mat-icon>help_outline</mat-icon>
      </a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <div>
      <div class="container" id="instruction-container">
        <mat-card appearance="outlined" class="card-container rightmost" id="instruction-card">
          <mat-card-title matLine id="key-title">
            {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.HEADER' | translate }}
          </mat-card-title>
          <mat-card-subtitle matLine [innerHTML]="'PAGES.SFTP.INSTRUCTIONS_MODAL.SUBHEADER' | translate">
            <!--You will need an SFTP client. We recommend using <a href="https://filezilla-project.org/" target="_blank">FileZilla</a>. It is free and available for Mac or PC.-->
          </mat-card-subtitle>
          <mat-card-content>
            <mat-card-title matLine id="instruction-title">
              {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.LIST.HEADER' | translate }}
            </mat-card-title>
            <ol id="instruction-list">
              <li>
                {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.LIST.STEP_1' | translate }}
              </li>
              <li>
                {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.LIST.STEP_2' | translate }}
                <strong>{{ sftpDomain }}</strong>
              </li>
              <li>
                {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.LIST.STEP_3' | translate }}
                <strong>22</strong>
              </li>
              <li>
                {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.LIST.STEP_4' | translate }}
              </li>
              <li>
                {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.LIST.STEP_5' | translate }}
              </li>
              <li>
                {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.LIST.STEP_6' | translate }}
                <strong>{{ siteUid$ | async }}</strong>
              </li>
              <li>
                {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.LIST.STEP_7' | translate }}
              </li>
              <li>
                {{ 'PAGES.SFTP.INSTRUCTIONS_MODAL.LIST.STEP_8' | translate }}
              </li>
            </ol>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="container" id="key-list-container">
        <mat-table id="key-list" #table [dataSource]="dataSource">
          <!-- Key's name column -->
          <ng-container matColumnDef="name">
            <mat-header-cell class="name-column" *matHeaderCellDef>
              {{ 'PAGES.SFTP.TABLE.HEADERS.KEY_NAME' | translate }}
            </mat-header-cell>
            <mat-cell class="name-column" *matCellDef="let element">
              {{ element.name }}
            </mat-cell>
          </ng-container>

          <!-- Key's Owner column -->
          <ng-container matColumnDef="createdBy">
            <mat-header-cell class="created-by-column" *matHeaderCellDef>
              {{ 'PAGES.SFTP.TABLE.HEADERS.CREATED_BY' | translate }}
            </mat-header-cell>
            <mat-cell class="created-by-column" *matCellDef="let element">
              {{ element.createdBy }}
            </mat-cell>
          </ng-container>

          <!-- Actions column -->
          <ng-container matColumnDef="actions">
            <mat-header-cell class="actions-column" *matHeaderCellDef>
              {{ 'PAGES.SFTP.TABLE.HEADERS.ACTIONS' | translate }}
            </mat-header-cell>
            <mat-cell class="actions-column" *matCellDef="let element">
              <button mat-icon-button matTooltip="Delete" (click)="showDeleteKeyDialog(element)">
                <mat-icon class="delete-icon">clear</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        @if (initialLoading) {
          <mat-spinner
            class="info-spinner"
            mode="indeterminate"
            color="accent"
            [diameter]="60"
            [strokeWidth]="8"
          ></mat-spinner>
        }
        <mat-paginator
          #paginator
          id="paginator-list"
          [length]="keyList.length"
          [pageIndex]="0"
          [pageSize]="10"
          [pageSizeOptions]="[10]"
        ></mat-paginator>
      </div>
    </div>
  </glxy-page-wrapper>
</glxy-page>
